import { useEffect } from "react";
import "./summercampsdetailshero.css";
import content_img from "../../Assets/Images/SummerCampDetails/summer_camp_flyerv2.png";
import { Link } from "react-router-dom";
import { useNewUser } from "../../APIContext/NewUserContext";

const SummerCampsDetailsHero = ({
  image = content_img,
  name1 = "SUMMER CAMP",
  description1 = "The camp is six weeks long this year. The dates are…",
  data,
  order = "left",
  buttonLink,
  buttonText = "Register Now",
}) => {
  const { loading, getSummerCampList, summercampList } = useNewUser();

  useEffect(() => {
    getSummerCampList();
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));

  function formatDateRange(start_date, end_date) {
    const months = {
      "01": "JANUARY",
      "02": "FEBRUARY",
      "03": "MARCH",
      "04": "APRIL",
      "05": "MAY",
      "06": "JUNE",
      "07": "JULY",
      "08": "AUGUST",
      "09": "SEPTEMBER",
      10: "OCTOBER",
      11: "NOVEMBER",
      12: "DECEMBER",
    };

    const getSuffix = (day) => {
      if (day.endsWith("11") || day.endsWith("12") || day.endsWith("13")) {
        return "TH";
      }
      if (day.endsWith("1")) return "ST";
      if (day.endsWith("2")) return "ND";
      if (day.endsWith("3")) return "RD";
      return "TH";
    };

    const [, startMonth, startDay] = start_date.split("-");
    const [, , endDay] = end_date.split("-");

    if (start_date === end_date) {
      return `${months[startMonth]} ${Number(startDay)}${getSuffix(startDay)}`;
    }

    return `${months[startMonth]} ${Number(startDay)}${getSuffix(startDay)} - ${Number(endDay)}${getSuffix(endDay)}`;
  }

  // Calculate status (Sold Out or time remaining)
  const getStatus = (week) => {
    if (week.remaining_capacity === 0) {
      return { text: "Sold Out", className: "sold-out" };
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const startDate = new Date(week.start_date);
    startDate.setHours(0, 0, 0, 0);

    const diffTime = startDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays < 0) {
      return { text: "Past Event", className: "past-event" };
    } else if (diffDays === 0) {
      return { text: "Today", className: "today" };
    } else if (diffDays === 1) {
      return { text: "1 Day Left", className: "urgent" };
    } else if (diffDays <= 7) {
      return { text: `${diffDays} Days Left`, className: "urgent" };
    } else if (diffDays <= 14) {
      const weeks = Math.floor(diffDays / 7);
      const days = diffDays % 7;
      if (days === 0) {
        return {
          text: `${weeks} Week${weeks > 1 ? "s" : ""} Left`,
          className: "upcoming",
        };
      } else {
        return {
          text: `${weeks} Week${weeks > 1 ? "s" : ""} ${days} Day${
            days > 1 ? "s" : ""
          } Left`,
          className: "upcoming",
        };
      }
    } else {
      const weeks = Math.floor(diffDays / 7);
      return { text: `${weeks} Weeks Left`, className: "upcoming" };
    }
  };

  return (
    <div className={`summercampsdetailshero-ss-block-ui ${order}`}>
      {/* LEFT SIDE: Image */}
      <div className="ssb-img">
        <img src={image} title={name1} alt="Summer Camp" />
      </div>

      {/*  Scrollable List Container  */}
      <div className="ssb-list-container">
        {summercampList.length > 0 &&
          summercampList.map((item) => {
            return (
              <div className="ssb-cnt" key={item?.id}>
                <div className="ssb-title">
                  <h2 className="text-clip">{item?.name}</h2>
                </div>

                <div className="ssb-desc">
                  <p className="text-clip" style={{ marginBottom: "20px" }}>
                    {item?.description}
                  </p>
                </div>

                <div className="ssb-desc event-details-stat-main-con">
                  {item?.weeks?.map((week) => {
                    const status = getStatus(week);
                    return (
                      <div className="event-details-stat" key={week?.id}>
                        <div className="event-details-stat-time">
                          <p className="text-clip">
                            WEEK {week?.week_number}{" "}
                            {formatDateRange(week?.start_date, week?.end_date)}{" "}
                            Location:
                          </p>
                        </div>
                        <div className="event-details-stat-details">
                          <span className="event-details-stat-details-span text-clip">
                            {week?.location_name}
                          </span>
                          <span
                            className={`event-details-stat-status text-clip ${status.className}`}
                          >
                            {status.text}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="ssb-desc">
                  <Link
                    to={`/register-summer-camp/${item?.id}/${
                      user ? "authenticated" : "new"
                    }`}
                    className="vb-btn"
                  >
                    <span className="text-clip">{buttonText}</span>
                  </Link>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SummerCampsDetailsHero;
